import React, { useState } from "react";
import { Backdrop, Box, Fade, Modal, Typography } from '@mui/material';
import { updateDescription } from "../../../../services/SocieteService";
import { useParams } from "react-router-dom";
import EditorCustom from "../../../../components/EditorCustorm/EditorCustom";
import LoadingButtonCustom from "../../../../components/LoadingButtonCustom/LoadingButtonCustom";
import { withSnackbar } from "../../../../utils/SnackbarHOC";
import { removeLineBreak } from "../../../../utils/EditorUtil";
import { AppButton } from "../../../../components/UI";
import Edit from '@mui/icons-material/Edit';

const paperStyle = {
  backgroundColor: '#fff',
  boxShadow: '0 20px 60px rgba(0,0,0,0.12)',
  padding: '24px 32px',
  borderRadius: '16px',
  maxWidth: '600px',
  width: '100%',
  outline: 'none',
};

function DescriptionModal({ snackbarShowMessage, description, setReloadDescription, reloadDescription }) {
  const [modalState, setModalState] = useState({ open: false });
  const [newDescription, setNewDescription] = useState("");
  const [loading, setLoading] = useState(false);
  const { id } = useParams();

  const handleOpen = () => {
    setModalState({ open: true });
    if (description) setNewDescription(description);
  };

  const handleClose = () => {
    if (!loading) setModalState({ open: false });
  };

  const handleSubmit = async () => {
    setLoading(true);
    const data = { description: removeLineBreak(newDescription) };
    try {
      snackbarShowMessage("Patientez svp!", "warning", null);
      const response = await updateDescription(data, id);
      snackbarShowMessage(response.data, "success", 4000);
      setReloadDescription(!reloadDescription);
    } catch (error) {
      snackbarShowMessage("Erreur de modification de la description!", "error", 4000);
    } finally {
      setLoading(false);
      handleClose();
    }
  };

  const editorCustomProps = { value: newDescription, setValue: setNewDescription, handleSubmit, enableOnBlur: false };
  const loadingButtonProps = { handleSubmit, handleUpdate: handleSubmit, loading, editMode: true };

  const body = (
    <div style={paperStyle}>
      <Typography sx={{ fontSize: '1rem', fontWeight: 700, color: '#0f172a', mb: 2, fontFamily: "'Fira Sans', sans-serif" }}>
        Modifier la description
      </Typography>
      <Typography sx={{ fontSize: '1rem', fontWeight: 700, color: '#64748b', letterSpacing: '0.06em', textTransform: 'uppercase', mb: 0.75 }}>
        Description
      </Typography>
      <EditorCustom id="note" {...editorCustomProps} />
      <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end', mt: 2.5 }}>
        <AppButton variant="secondary" onClick={handleClose} disabled={loading}>
          Annuler
        </AppButton>
        <LoadingButtonCustom {...loadingButtonProps} />
      </Box>
    </div>
  );

  return (
    <>
      {localStorage.getItem("rolecurrentuser") !== "ROLE_CONSULTANT" && (
        <AppButton variant="primary" onClick={handleOpen} disabled={loading} size="small" startIcon={<Edit fontSize="small" />} sx={{ mb: 1.5 }}>
          Modifier la description
        </AppButton>
      )}
      <Modal
        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        open={modalState.open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{ timeout: 500 }}
      >
        <Fade in={modalState.open}>{body}</Fade>
      </Modal>
    </>
  );
}

export default withSnackbar(DescriptionModal);
